// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__1WxZh","checkableItem":"Checkbox_checkableItem__3raOt","noTab":"Checkbox_noTab__130kw"};